import { render, staticRenderFns } from "./WorkspaceRow.vue?vue&type=template&id=ec2c3f28&"
import script from "./WorkspaceRow.vue?vue&type=script&lang=js&"
export * from "./WorkspaceRow.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports